<script lang="ts">
	import Chip from './Chip.svelte'

	// For normal mode, selectedItems represents the current chips.

	interface Props {
		// In filter mode, selectedItems represents the available filter options.
		selectedItems?: string[]
		placeholderText?: string
		label?: string
		error?: string
		isFilterGroup?: boolean
		onRemove?: ((item: string) => void) | null
		onfilterSelect?: ((item: string | null) => void) | null
	}

	let {
		selectedItems = $bindable([]),
		placeholderText = '',
		label = '',
		error = '',
		isFilterGroup = false,
		onRemove = null,
		onfilterSelect = null
	}: Props = $props()

	let currentFilter: string | null = $state(null)

	$effect(() => {
		if (isFilterGroup && selectedItems.length > 0 && currentFilter === null) {
			currentFilter = selectedItems[0]
		}
	})

	function handleChipRemove(text: string) {
		onRemove?.(text)
	}

	function handleChipClick(item: string) {
		if (currentFilter === item) {
			currentFilter = null
			onfilterSelect?.(null)
		} else {
			currentFilter = item
			onfilterSelect
		}
	}
</script>

<div class="label-container">
	{#if label}
		<div>{label}</div>
	{/if}
	{#if error}
		<div class="error-text">{error}</div>
	{/if}
</div>
<div class="chip-group">
	{#if isFilterGroup}
		{#each selectedItems as item (item)}
			<Chip
				text={item}
				removable={false}
				isSelected={currentFilter === item}
				customClass={currentFilter === item ? 'chip-selected' : 'chip-unselected'}
				isFilterChip={true}
				onclick={() => handleChipClick(item)}
			/>
		{/each}
		{#if selectedItems.length === 0}
			<div class="placeholder">{placeholderText}</div>
		{/if}
	{:else}
		{#each selectedItems as item (item)}
			<Chip text={item} onRemove={handleChipRemove} isFilterChip={false} />
		{/each}
		{#if selectedItems.length === 0}
			<div class="placeholder">{placeholderText}</div>
		{/if}
	{/if}
</div>

<style>
	.label-container {
		@apply block;
	}

	.chip-group {
		@apply flex flex-wrap p-2 min-h-12;
	}

	.placeholder {
		@apply text-black italic;
	}

	.error-text {
		@apply text-red-500 mt-1;
	}
</style>
